import {
  Tab as ReachTab,
  TabList as ReachTabList,
  TabListProps,
  TabPanels as ReachTabPanels,
  TabPanelsProps,
  TabProps,
  Tabs as ReachTabs,
  TabsProps,
} from "@reach/tabs";
import React, { useState } from "react";
import styled from "styled-components";
import { SelectMenu, Item } from "./SelectMenu";
import { selectedTabStyle, tabListStyle, tabStyle } from "./TabStyles";

import { mediaQueries, MediaQueryWrapper, style } from "./style";

type RestrictedTabsProps = {
  selectMenuBreakpoint?: MediaQueryWrapper;
  onChange?: (index: number) => void;
  children: React.ReactElement[];
  className?: string;
} & TabsProps;

const ResponsiveTabs: React.FC<RestrictedTabsProps> = ({ onChange, defaultIndex = 0, children, className, ...rest }) => {
  const [tabIndex, setTabIndex] = useState(defaultIndex);
  const isMobile = mediaQueries.xsmallMax.useMatchesBreakpoint();
  const childrenArray = React.Children.toArray(children);

  const Panes = childrenArray.find((c) => React.isValidElement(c) && c.type === TabPanels);
  let Selector = childrenArray.find((c) => React.isValidElement(c) && c.type === TabList);

  if (isMobile) {
    const items = React.Children.map(React.isValidElement(Selector) ? Selector.props.children : [], (c: React.ReactElement, i) => {
      return {
        label: c.props.children.toString(),
        value: i.toString(),
      };
    });
    const setSelection = (selection: Item) => {
      setTabIndex(items.indexOf(selection));
    };

    Selector = (
      <SelectMenu
        className={className}
        items={items}
        selection={items[tabIndex]}
        setSelection={(item) => {
          setSelection(item);
          if (onChange) {
            onChange(items.findIndex((singleItem) => singleItem === item));
          }
        }}
      />
    );
  }

  return (
    <ReachTabs
      className={className}
      index={tabIndex}
      onChange={(index) => {
        setTabIndex(index);
        if (onChange) {
          onChange(index);
        }
      }}
      defaultIndex={defaultIndex}
      {...rest}
    >
      {Selector}
      {Panes}
    </ReachTabs>
  );
};

/**
 * @deprecated Use `Tabs` instead.
 */
export const TabbedContent = styled(ResponsiveTabs)<TabsProps>`
  &[data-reach-tabs] {
    margin-top: ${style.vars.space["5"]};
  }
`;

/**
 * @deprecated Use `Tabs` instead.
 */
export const TabList = styled(ReachTabList)<TabListProps>`
  &[data-reach-tab-list] {
    ${tabListStyle}
  }
`;

/**
 * @deprecated Use `Tabs` instead.
 */
export const Tab = styled(ReachTab)<TabProps>`
  display: inline-block;

  &[data-reach-tab] {
    ${tabStyle}

    &[data-selected] {
      ${selectedTabStyle}
    }
  }
`;

/**
 * @deprecated Use `Tabs` instead.
 */
export const TabPanels = styled(ReachTabPanels)<TabPanelsProps>`
  &[data-reach-tab-panels] {
    margin-top: ${style.vars.space["5"]};
  }
`;

export { TabPanel } from "@reach/tabs";
